import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as UserActions from './../actions/user_actions';
import { ModalDialogCommon } from './modal_dialog_common';
import { bindActionCreators } from 'redux';
import { Loader } from './loader';


let MultifacilityRequest = React.createClass({
    getInitialState() {
        return {
            showLoader: null,onconfirm:false,
            confimationModalMessage: null,clinicSelected:false,
        }
    },
    componentWillMount() {
      // redirection to login page, if another user session already exists.

      if (this.props.UserDetails && this.props.UserDetails.loginData && this.props.UserDetails.loginData.status === 200) {
          this.setState({ confimationModalMessage: 'You need to logout the current session to register a new account.' });
          return;
      }
      else{
        function getParameterByName(name, url) {

            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }
        var token = getParameterByName('token', window.location.href);
        var urlData = token.split('#');
        let actionData = window.location.href.split('&')[1] === "action=1";
        let action = actionData ? 1 : 0;
        let data=urlData[1]+"/"+urlData[3]+"/"+action;
        this.props.Dispatch(UserActions.MultifacilityRequest(data));
        this.props.router.push('/');
      }
    },
    componentWillReceiveProps(nextProps) {
       
      if(this.state.onconfirm){
        this.props.Dispatch(UserActions.user_log_out());
          this.setState({onconfirm:false,confimationModalMessage:null})
      // location.reload();
    }else {
      function getParameterByName(name, url) {

          if (!url) url = window.location.href;
          name = name.replace(/[\[\]]/g, "\\$&");
          var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
              results = regex.exec(url);
          if (!results) return null;
          if (!results[2]) return '';
          return decodeURIComponent(results[2].replace(/\+/g, " "));
      }
      var token = getParameterByName('token', window.location.href);
      var urlData = token.split('#');
      let actionData = window.location.href.split('&')[1] === "action=1";
      let action = actionData ? 1 : 0;
      let data=urlData[1]+"/"+urlData[3]+"/"+action;
      this.props.Dispatch(UserActions.MultifacilityRequest(data));
      this.props.router.push('/');
    }
    },
    componentDidMount() {

    },

    closeBoxOnScuess() {
        this.setState({ okModalMsg: null });
    },
    closeConfirmationModal() {
        this.setState({ confimationModalMessage: null });
        this.props.router.push('/');
    },
    onConfirmed() {
      this.setState({onconfirm:true})
        this.props.Dispatch(UserActions.logout(
            {
                "appType": "WEB",
                "id": this.props.UserDetails.loginData.data.id
            }
        ));

    },
    render() {

        return (
          <div className="dashboard-inner-content container">
              <div className="row">

              </div>

              {this.state.confimationModalMessage && <ModalDialogCommon message={this.state.confimationModalMessage} cancel="true" action2={this.closeConfirmationModal} action={this.onConfirmed} />}
          </div>
        );
    }
});

let mapStateToProps = (state) => {
    return {
        UserDetails: state.User,
        SessionLogoutResponse: state.User.sessionLogoutResponse,
    };
};

let mapDispatchToProps = (dispatch) => ({
    UserActions: bindActionCreators(UserActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(MultifacilityRequest));
// End - ResetPassword Componen



/** WEBPACK FOOTER **
 ** ./src/components/multi-facility-request.jsx
 **/